import { LeftSideMenu } from "../../components/leftSideMenu/LeftSideMenu";
import { useSpreadsheet } from "../../hooks";
import DragDropInput from "../../components/form/DragDropInput";
import { parseFormData } from "../../data-parsing/parseUtils";
import { InputTypes } from "../../data-parsing/InputTypes";
import { useRef, useState } from "react";
import { CreationFormInput } from "../../components/form/CreationForm";
import { OptionsSources } from "../../data-parsing/OptionsSources";

export function EatmeManagement() {
  const { postSpreadsheet } = useSpreadsheet();
  const [sheetNames, setSheetNames] = useState([]);
  const selectRef = useRef();

  const onSubmit = (e) => {
    e.preventDefault();
    let data = parseFormData(document.getElementById("fSpreadsheet"))[0];
    if (data.spreadsheet && data.spreadsheet.size > 0) {
      let fileReader = new FileReader();
      fileReader.readAsDataURL(data.spreadsheet);
      fileReader.onload = (event) => {
        let fileData = event.target.result;
        console.log(fileData);
        postSpreadsheet(
          fileData,
          /*           selectRef.current?.getValue().map((option) => {
            return option.value;
          }) */
          sheetNames
        );
      };
    }
  };

  const handleChange = (file, name) => {
    if (name === "spreadsheet" && file.size > 0) {
      let fileReader = new FileReader();
      fileReader.readAsBinaryString(file);
      //fileReader.readAsDataURL(data.spreadsheet);
      fileReader.onload = (event) => {
        let fileData = event.target.result;
        const XLSX = require("xlsx");
        const workbook = XLSX.read(fileData, { type: "binary" });
        setSheetNames(workbook.SheetNames);
      };
    }
  };

  return (
    <LeftSideMenu active="management">
      <div id="wrapper">
        <div className="container">
          <div className="row">
            <form id="fSpreadsheet" onSubmit={onSubmit}>
              <div className="col-xs-12">
                <div className="card-box card-tabs m-t-20">
                  <CreationFormInput
                    name={"sheetNames"}
                    size={1}
                    ref={selectRef}
                    inputData={{
                      type: InputTypes.MULTIPLE_SELECT,
                      visibleName: "Hojas de datos",
                      optionsMapping: {
                        source: OptionsSources.INLINE,
                        options: sheetNames.map((name) => {
                          return { value: name, label: name };
                        }),
                      },
                    }}
                  />

                  <div className="form-group">
                    <label>Hoja de datos</label>

                    <DragDropInput
                      name="spreadsheet"
                      single={true}
                      fileTypes={["xlsx", "xlsm"]}
                      style={{ height: "400px" }}
                      onChangeCallback={handleChange}
                    />
                  </div>
                  <button
                    id="btnSubmit"
                    className="btn btn-rounded btn-purple m-t-20"
                  >
                    <i className="fa fa-cloud-upload" aria-hidden="true"></i>{" "}
                    Cargar Datos
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </LeftSideMenu>
  );
}
